export default __webpack_public_path__ + "static/media/DogSad.d4a8dbf9.svg";